import { createFeatureSelector } from '@ngrx/store';
import { ShowDetailDataState } from '@store/show-detail/show-detail.reducer';

export const showDetailDataState = createFeatureSelector<ShowDetailDataState>('showDetail');
